import { CustomCheckboxInput, QuestionCard } from '@my/ui'
import { Control, useWatch } from 'react-hook-form'

import { DropdownField, InputField } from '../helpers/Helper'
import images from '../../../assets/images'
import {
  April2026UpdatedOptions,
  confirmationOptions,
  financialSecurityPlanOPtions,
  insurancePoliciesOptions,
} from '../data'

interface FinancialSecurityProps {
  control: Control<any>
}

export const FinancialSecurity: React.FC<FinancialSecurityProps> = ({ control }) => {
  const insurancePoliciesHoldFormValue = useWatch({ name: "Financial Security - Insurance Policies Held"});
  
  const accountsWithDesigneesFormValue = useWatch({ name: "Financial Security - Beneficiaries - Do Accounts have Designees"});
  const hasDesignees = ['Yes, all accounts', 'Some accounts'].includes(accountsWithDesigneesFormValue);

  const hasEstablishedPlanFormValue = useWatch({name: "Financial Security - Established Estate Plan or Will"})
  const hasEstablishedPlan = [true, 'Yes, up to date (reviewed within 2 years)', 'Yes, but outdated'].includes(hasEstablishedPlanFormValue);
  return (
    <>
      {/* <QuestionCard questionGroupTitle="Do you have a plan for financial emergencies?">
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Financial Security - Financial Emergencies"
        />
      </QuestionCard> */}
      <QuestionCard questionGroupTitle="Have you established an estate plan or a will?">
        <DropdownField
          control={control}
          name="Financial Security - Established Estate Plan or Will"
          items={April2026UpdatedOptions['Retirement Planning'].estatePlanStatus}
          //label="Do you know the source of your Life Insurance?"
          //showLabel
          native
        />
      </QuestionCard>
      {hasEstablishedPlan && <QuestionCard questionGroupTitle="If Yes, please specify which one">
        <CustomCheckboxInput
          options={financialSecurityPlanOPtions}
          control={control}
          name="Financial Security - Established plan type"
          circle
        />

        <InputField
          control={control}
          name="Financial Security - Established plan Description"
          placeholder="Additional Notes"
          height={90}
          multiline
        />
      </QuestionCard>}
      <QuestionCard questionGroupTitle="Have you designated beneficiaries on all your financial accounts (retirement, insurance, brokerage)?">
        <DropdownField
          control={control}
          name="Financial Security - Beneficiaries - Do Accounts have Designees"
          items={April2026UpdatedOptions['Retirement Planning'].beneficiaryDesignationStatus}
          native
        />
      </QuestionCard>
      {hasDesignees && <QuestionCard questionGroupTitle="Who are your primary beneficiaries?">
        <CustomCheckboxInput
          control={control}
          name="Financial Security - Beneficiaries"
          options={April2026UpdatedOptions['Retirement Planning'].primaryBeneficiaries}
          multiple
        />
      </QuestionCard>}
      <QuestionCard questionGroupTitle="Do you have a healthcare proxy and/or power of attorney?">
        <DropdownField
          control={control}
          name="Financial Security - Has Healthcare Proxy and/or Power of Attorney"
          items={April2026UpdatedOptions['Retirement Planning'].proxyAndPowerOfAttorney}
          native
        />
      </QuestionCard>

      <QuestionCard questionGroupTitle="Which Insurance Policies Do You Currently Hold?">
        <CustomCheckboxInput
          options={insurancePoliciesOptions}
          control={control}
          name="Financial Security - Insurance Policies Held"
          multiple
        />
      </QuestionCard>
      {(insurancePoliciesHoldFormValue || []).includes('Health Insurance') ? <QuestionCard questionGroupTitle="Health Insurance">
        <DropdownField
          control={control}
          name="Financial Security - Health Insurance Source"
          items={April2026UpdatedOptions['Retirement Planning'].healthInsuranceSource}
          label="Do you know the source of your Health Insurance?"
          showLabel
          native
        />
        <DropdownField
          control={control}
          name="Financial Security - Health Insurance - Is HDHP"
          items={April2026UpdatedOptions['Retirement Planning'].genericYesNoNotSure}
          label="Is your health insurance plan a High-Deductible Health Plan (HDHP)?"
          showLabel
          native
        />
      </QuestionCard> : null}
      {(insurancePoliciesHoldFormValue || []).includes('Life Insurance') ? <QuestionCard questionGroupTitle="Life Insurance">
        <DropdownField
          control={control}
          name="Financial Security - Life Insurance Source"
          items={April2026UpdatedOptions['Retirement Planning'].lifeInsuranceSource}
          label="Do you know the source of your Life Insurance?"
          showLabel
          native
        />
        <DropdownField
          control={control}
          name="Financial Security - Life Insurance - Coverage Amount"
          items={April2026UpdatedOptions['Retirement Planning'].lifeInsuranceCoverageAmount}
          label="What is your approximate total life insurance coverage amount (death benefit)?"
          showLabel
          native
        />
      </QuestionCard> : null}
      {(insurancePoliciesHoldFormValue || []).includes('Disability Insurance') ? <QuestionCard questionGroupTitle="Disability Insurance">
        <DropdownField
          control={control}
          name="Financial Security - Disability Insurance Source"
          items={April2026UpdatedOptions['Retirement Planning'].disabilityInsuranceSource}
          label="Do you know the source of your Disability Insurance?"
          showLabel
          native
        />
        <DropdownField
          control={control}
          name="Financial Security - Disability Insurance - Coverage Percentage"
          items={April2026UpdatedOptions['Retirement Planning'].disabilityCoveragePercentage}
          label="Approximately what percentage of your income does your disability insurance cover?"
          showLabel
          native
        />
      </QuestionCard> : null}
    </>
  )
}
